import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { getBrand } from "../../services/brand.service";

export default function BrandDetails() {
  const { token } = useSelector((state) => state?.auth);
  const [brand, setBrand] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const brandId = queryParams.get("id");
  const backPage = queryParams.get("page");
  const search = queryParams.get("search");

  const fetchBrand = async () => {
    try {
      const res = await getBrand(token, brandId);

      if (res && res.status >= 200 && res.status < 300) {
        setBrand(res?.data);
      } else {
        Swal.fire(
          "Error",
          "Failed to fetch brand details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching brand details:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching the brand. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (brandId) {
      fetchBrand();
    }
  }, [brandId]);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Brand Details</h4>
                <Link to={`/brands?page=${backPage}${
                search ? `&search=${search}` : ""
              }`}>
                  <img src="/assets/images/kidskart/icon/back-button.png" />
                </Link>
              </div>
              <div className="card-body">
                <div className="row">
                  {/* Brand Name */}
                  <div className="col-sm-6 mb-4">
                    <h5>Brand Name</h5>
                    <p>{brand?.brand_name || "N/A"}</p>
                  </div>

                  {/* Acronym */}
                  <div className="col-sm-6 mb-4">
                    <h5>Acronym</h5>
                    <p>{brand?.acronym || "N/A"}</p>
                  </div>

                  {/* Brand Logo */}
                  <div className="col-sm-6 mb-4">
                    <h5>Brand Logo</h5>
                    {brand?.image ? (
                      <img
                        src={brand?.image}
                        alt="Brand"
                        className="img-thumbnail"
                        style={{ width: "200px" }}
                      />
                    ) : (
                      <p>No Brand Logo Available</p>
                    )}
                  </div>

                  {/* In Stock */}
                  <div className="col-sm-6 mb-4">
                    <h5>In Stock</h5>
                    <p>{brand?.in_stock ? "Yes" : "No"}</p>
                  </div>

                  {/* Description */}
                  <div className="col-md-12 mb-4">
                    <h5>Description</h5>
                    <p>{brand?.description || "No description provided"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
